// get a random number within a range
function random( min: number, max: number ) {
    return min + Math.random()*(max-min);
}

// calculate the distance between two points
function calculateDistance( p1x: number, p1y: number, p2x: number, p2y: number ) {
    return Math.sqrt((p1x-p2x)*(p1x-p2x) + (p1y-p2y)*(p1y-p2y));
}
// current year
function year(): number {
    return new Date().getFullYear();
}

/*
function requestInterval(fn: any, delay: number) {
    if( !window.requestAnimationFrame)
        return window.setInterval(fn, delay);

    let start = new Date().getTime(),
        handle = {
            value: undefined
        };

    function loop() {
        const current = new Date().getTime(),
            delta = current - start;

        if(delta >= delay) {
            fn.call();
            start = new Date().getTime();
        }

        handle.value = requestAnimFrame(loop);
    };

    handle.value = requestAnimFrame(loop);
    return handle;
}*/

export {random, calculateDistance, year}
